import { render, staticRenderFns } from "./createCaseForm.vue?vue&type=template&id=420f2007&scoped=true"
import script from "./createCaseForm.vue?vue&type=script&lang=js"
export * from "./createCaseForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "420f2007",
  null
  
)

export default component.exports